import Muuri from 'muuri/dist/muuri.min.js';

const Fundraisers = () => {
    document.addEventListener('DOMContentLoaded', function () {
      
        var grid = null;
        var demo = document.querySelector('.fundraisers');
        var gridElement = demo.querySelector('.grid');
        var searchField = demo.querySelector('.search-field');
        var searchFieldValue;
      
        function initItems() {
      
          initGrid();
      
          // Set inital search query, active filter, active sort value and active layout.
          searchFieldValue = searchField.value.toLowerCase();
      
          // Search field binding.
          searchField.addEventListener('keyup', function () {
            var newSearch = searchField.value.toLowerCase();
            if (searchFieldValue !== newSearch) {
              searchFieldValue = newSearch;
              filter();
            }
          });
      
        }
        
        // muuri options
        function initGrid() {
            
          grid = new Muuri(gridElement, {
            items: '*',
            layoutDuration: 400,
            layoutEasing: 'ease',
            dragEnabled: false,
          })
      
        }
      
        // search the data-title for search results
        function filter() {
      
          grid.filter(function (item) {
            var element = item.getElement();
            var isSearchMatch = !searchFieldValue ? true : (element.getAttribute('data-title') || '').toLowerCase().indexOf(searchFieldValue) > -1;
            return isSearchMatch;
          });
      
        }
      
        // initialise
      initItems();
      
      });
}



export default Fundraisers;